import { ref } from '@vue/composition-api'
import draftEventMembersApi from '@/services/api/draftEventMembers'
import EventBus from '@/store/EventBus'

function mapUser(u) {
  return {
    id: u.primary_user_id,
    memberNumber: u.member_number,
    primaryName: u.mailing_name,
    phone: u.mobile_number,
    email: u.email,
    totalCost: u.invoice != null && u.invoice.total_cost != null ? u.invoice.total_cost : u.total_cost,
    hasInvoice: u.invoice != null,
    invoiceSent: u.invoice != null ? u.invoice.is_sent : false,
    subMembers: (u.members != null ? u.members : []).map(m => ({
      id: m.id,
      name: `${m.first_name != null ? m.first_name : ''} ${m.last_name != null ? m.last_name : ''}`.trim(),
      upgraded: m.upgraded_at != null,
      scratched: m.status === 'scratched',
      paid: m.is_paid
    }))
  }
}

export default function useDraftEventMembers(draftId) {
  const members = ref([])
  const draftName = ref('')
  const loading = ref(false)

  async function fetchMembers() {
    loading.value = true
    try {
      const res = await draftEventMembersApi.getMembers(draftId)
      const payload = res.data.data
      draftName.value = payload.draft_name != null ? payload.draft_name : ''
      const users = Array.isArray(payload.members) ? payload.members : []
      members.value = users.map(mapUser)
    } catch (_) {
      members.value = []
    } finally {
      loading.value = false
    }
  }

  async function updatePaymentStatus(primaryUserId, data) {
    try {
      const res = await draftEventMembersApi.updatePaymentStatus(draftId, primaryUserId, data)
      if (res.data.message) EventBus.$emit('show-success', res.data.message)
      await fetchMembers()
    } catch (_) { /* http.js handles toast */ }
  }

  async function scratchMember(eventMemberId) {
    try {
      const res = await draftEventMembersApi.updateMemberStatus(draftId, eventMemberId)
      if (res.data.message) EventBus.$emit('show-success', res.data.message)
      await fetchMembers()
    } catch (_) { /* http.js handles toast */ }
  }

  return {
    members,
    draftName,
    loading,
    fetchMembers,
    updatePaymentStatus,
    scratchMember
  }
}



// WEBPACK FOOTER //
// ./src/composables/draftEventMembers/useDraftEventMembers.js